import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { waLink } from "@/lib/site";

export const Footer = () => (
  <footer className="bg-[#121518] text-[#FAF8F5] pt-20 pb-10 overflow-hidden" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid md:grid-cols-3 gap-10 pb-16 border-b border-[#FAF8F5]/15">
        <Logo light />
        <div className="text-sm text-[#FAF8F5]/75 space-y-2">
          <p>Limpeza comercial para escritórios, clínicas e empresas</p>
          <p>Faxina residencial e limpeza pesada</p>
          <p>Limpeza pós-obra residencial e comercial</p>
        </div>
        <div className="text-sm text-[#FAF8F5]/75 space-y-2 md:text-right">
          <a href={waLink()} target="_blank" rel="noreferrer" className="block hover:text-[#C59B27]" data-testid="footer-whatsapp">WhatsApp 11 99457-6696</a>
          <p>São Paulo · SP</p>
        </div>
      </div>
      <p className="font-serif-d text-[17vw] leading-[0.85] tracking-tight text-[#FAF8F5]/10 mt-10 select-none whitespace-nowrap">Limpeza Rápida</p>
      <div className="flex justify-between items-center mt-6 text-xs text-[#FAF8F5]/60">
        <span>© 2026 Limpeza Rápida SP</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#FAF8F5]">Área administrativa</Link>
      </div>
    </div>
  </footer>
);
